import { Button } from "../../components/Button/Button.tsx";
import { EmptyState } from "../../components/EmptyState/EmptyState.tsx";
import type { IconName } from "../../components/Icon/Icon.tsx";
import { TextField } from "../../components/TextField/TextField.tsx";

export const ViewLayout = ({
  title,
  leftContent,
  children,
  emptyStateProps,
  searchTextProps,
  creationButtonProps,
  isEmpty = false,
}: {
  title: string;
  leftContent?: React.ReactNode;
  children: React.ReactNode;
  emptyStateProps?: {
    iconName: IconName;
    title: string;
    header: string;
    description: string;
    buttonLabel: string;
  };
  searchTextProps?: {
    searchText: string;
    setSearchText: (text: string) => void;
  };
  creationButtonProps?: {
    label: string;
    onClick: () => void;
    loading?: boolean;
  };
  isEmpty?: boolean;
}) => (
  <BaseViewLayout
    title={title}
    children={
      isEmpty && emptyStateProps && creationButtonProps ? (
        <EmptyState
          iconName={emptyStateProps.iconName}
          title={emptyStateProps.title}
          header={emptyStateProps.header}
          description={emptyStateProps.description}
          className="pt-[10vh]"
        >
          <Button
            className="w-[120px]"
            onClick={creationButtonProps.onClick}
            loading={creationButtonProps.loading}
          >
            {creationButtonProps.label}
          </Button>
        </EmptyState>
      ) : (
        children
      )
    }
    header={
      <div className="flex-row h-600 items-center justify-between">
        {leftContent ?? <div />}
        {!isEmpty && (
          <div className="flex-row gap-200">
            {searchTextProps && (
              <TextField
                placeholder="Search..."
                size="md"
                value={searchTextProps.searchText}
                onChange={(text) => {
                  searchTextProps.setSearchText(text.toLowerCase());
                }}
                iconName="Search"
                className="w-[192px]"
              />
            )}
            {creationButtonProps && (
              <Button
                className="text-truncate w-[120px]"
                size="md"
                onClick={creationButtonProps.onClick}
                loading={creationButtonProps.loading}
              >
                {creationButtonProps.label}
              </Button>
            )}
          </div>
        )}
      </div>
    }
  />
);

const BaseViewLayout = ({
  title,
  children,
  header,
}: {
  title: string;
  header: React.ReactNode;
  children: React.ReactNode;
}) => (
  <div className="pt-400 h-full flex-col">
    <div className="px-800 py-400 flex-col gap-200">
      <div className="min-h-800 heading-2xl flex-row items-center">{title}</div>
      {header}
    </div>
    <div className="px-800 pb-400 flex-fill overflow-y-auto">{children}</div>
  </div>
);
